import escapeHtml from 'Util/escapeHtml';
import Metadata from './Metadata';

function toXml(envelope) {
  var ret = '', authContainer, auth = envelope.auth.getData();
  var requestGroup = envelope.getRequestGroup();
  var subRequests = envelope.getSubRequests();

  // hack to get container name
  for (authContainer in auth) {
    break;
  }

  var authString = xmlTagSerialize(authContainer, auth[authContainer]);

  var requestAttrs = {};
  var outputFormat = envelope.getOutputFormat();
  var errorURL     = envelope.getErrorURL();

  if (outputFormat != 'xml')
    requestAttrs.outputFormat = outputFormat;

  if (errorURL)
    requestAttrs.errorURL = errorURL;

  ret = xmlTagSerialize('request', requestAttrs, true);
  ret += authString;

  if (subRequests.length) {
    ret += '<requestList>';

    subRequests.forEach(function(cur) {
      var methodDefinition = Metadata.getMethodDefinition(requestGroup, cur.name),
          hasChildren      = false,
          newParams        = {},
          childParams      = {};

      ret += '<requestItem';

      if (cur.requestID)
        ret += ' id="' + escapeHtml(cur.requestID) + '"';

      ret += '>';

      Object.keys(cur.params).forEach(function(paramName) {
        var paramDefinition = methodDefinition.parameters[paramName],
            paramVal = cur.params[paramName];

        if (paramDefinition.type != 'array') {
          newParams[paramName] = paramVal;
        } else {
          hasChildren = true;
          childParams[paramName] = paramVal;
        }
      });

      ret += xmlTagSerialize(cur.name, newParams, hasChildren);

      // serialize array parameter child elements
      Object.keys(childParams).forEach(function(paramName) {
        var paramDefinition = methodDefinition.parameters[paramName];

        ret += '<' + paramName + '>';

        childParams[paramName].forEach(function(childElement) {
          var childAttributes = {};
          childAttributes[paramDefinition.xmlValueAttributeName] = childElement;
          ret += xmlTagSerialize(paramDefinition.xmlMainElementName, childAttributes);
        });

        ret += '</' + paramName + '>';
      });

      if (hasChildren)
        ret += '</' + cur.name + '>';

      ret += '</requestItem>';
    });

    ret += '</requestList>';
  }

  ret += '</request>';

  return ret;
}

function xmlTagSerialize(tagName, attributes, keepOpen) {
  var ret = '<' + tagName;

  for (var attr in attributes) {
    ret += ' ' + attr + '="' + escapeHtml(attributes[attr]) + '"';
  }

  if (!keepOpen)
    ret += '/';

  ret += '>';

  return ret;
}

function toQueryString(envelope) {
  var authParamName, authParamValue, ret = '', authContainer, auth = envelope.auth.getData();
  var subRequests = envelope.getSubRequests();

  var requestGroup = envelope.getRequestGroup();

  var errorURL = envelope.getErrorURL();

  // hack to get container name
  for (authContainer in auth) {
    break;
  }

  auth = auth[authContainer];

  if (authContainer == 'authNone') {
    ret = 'authNone=1';
  } else if (authContainer == 'authToken') {
    ret = 'authToken=' + encodeURIComponent(auth.token);
  } else {
    for (authParamName in auth) {
      authParamValue = auth[authParamName];

      if (ret)
        ret += '&';

      ret += authContainer + authParamName.charAt(0).toUpperCase() + authParamName.slice(1);
      ret += '=' + encodeURIComponent(authParamValue);
    }
  }

  ret += '&outputFormat=' + encodeURIComponent(envelope.getOutputFormat());

  if (errorURL)
    ret += '&errorURL=' + encodeURIComponent(errorURL);

  if (subRequests.length != 1)
    throw new Error('Expected exactly one subrequest');

  var subRequest = subRequests[0];

  ret += '&requestType' + '=' + encodeURIComponent(subRequest.name);

  var methodDefinition = Metadata.getMethodDefinition(requestGroup, subRequest.name);

  Object.keys(subRequest.params).forEach(function(paramName) {
    var paramDefinition = methodDefinition.parameters[paramName],
        paramVal = subRequest.params[paramName];

    if (paramDefinition.type == 'array') {
      paramVal.forEach(function(value) {
        ret += '&' + paramName + '[]=' + value;
      });
    } else {
      if (paramVal && typeof paramVal === 'object') {
        // workaround for object params until proper support is implemented in here and in API
        paramVal = '';
      }
      ret += '&' + paramName + '=' + encodeURIComponent(paramVal);
    }
  });

  return ret;
}

export default {
  serialize : function(type, envelope) {
    switch (type) {
    case 'json':
      if (envelope.getOutputFormat() === 'json')
        envelope.setOutputFormat(null);

      return JSON.stringify(envelope.getJson(), null, 2);

    case 'xml':
      return toXml(envelope);

    case 'get':
    case 'post':
      return toQueryString(envelope);
    }
  }
};
